module.exports = __webpack_public_path__ + "static/media/am_place-a-hold.0d5fa0ad.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_place-a-hold.md
// module id = 1089
// module chunks = 0